import { render } from "./CappPaymentDetails.vue?vue&type=template&id=3583b0bc&ts=true"
import script from "./CappPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./CappPaymentDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__